import { useStatePolicyResults } from '@/lib/hooks'
import { EmptyState } from '@/shared/components/EmptyState'

/** Per-version state policy verdicts (C). Mirrors the module version PolicyResultsCard. */
export function StatePolicyTab({ orgId, workspace, versionId }: { orgId: string; workspace: string; versionId: string }) {
  const { data, loading } = useStatePolicyResults(orgId, workspace, versionId)
  const results = data?.policy_results ?? []
  if (loading) return <span className="spinner" />
  if (results.length === 0) {
    return <EmptyState icon="⬡" title="No policy results for this version." subtitle="Either no state policies are enabled, or this version predates policy evaluation." />
  }
  const failing = results.filter((r) => !r.passed).length
  return (
    <div style={{ display: 'grid', gap: 8 }}>
      <div style={{ fontFamily: 'var(--mono)', fontSize: '0.65rem', color: 'var(--text3)', letterSpacing: '0.08em' }}>
        // {failing > 0 ? `${failing} failing` : 'all passing'}
      </div>
      {results.map((r) => (
        <div key={r.policy_id} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 6, padding: '8px 12px' }}>
          <span style={{ color: r.passed ? 'var(--green)' : 'var(--red)', fontSize: '0.8rem' }}>{r.passed ? '✓' : '✗'}</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '0.8rem', color: 'var(--text)' }}>{r.policy_name}</div>
            {!r.passed && r.failure_msg && (
              <div style={{ fontSize: '0.72rem', color: 'var(--text2)', marginTop: 2 }}>{r.failure_msg}</div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
